import { Card } from './Card'

export const InternalMovement = ({ data, isLoading, filter, onSubmitFilter, years }) => {
    return (
        <Card
            isLoading={isLoading}
            title={
                <div>
                    <div>Internal Movement Breakdown</div>
                    <div className='text-base text-neutral-60'>Analysis of talent mobility across departments</div>
                </div>
            }
            filterTitle='Filter Internal Movement'
            initFilter={filter}
            initOptions={{ year: years }}
            onSubmitFilter={onSubmitFilter}
        >
            <div className='grid grid-cols-3 gap-6 my-4'>
                {data?.map((item, index) => (
                    <Progress
                        key={index}
                        label={item?.label}
                        count={item?.count}
                        percentage={item?.percentage}
                        bgColor={item?.bgColor}
                        textColor={item?.textColor}
                    />
                ))}
            </div>
        </Card>
    )
}

const Progress = ({ label, count, percentage, bgColor, textColor }) => {
    return (
        <div>
            <div className='flex justify-between text-sm font-semibold mb-1'>
                <div>{label}</div>
                <div className={`flex gap-1 ${textColor}`}>
                    <div>{count}</div>
                    <div>({percentage}%)</div>
                </div>
            </div>

            <div className='w-full h-2 bg-neutral-20 rounded'>
                <div className={`h-2 rounded ${bgColor}`} style={{ width: `${percentage}%` }} />
            </div>
        </div>
    )
}
